import ContentEventApi from '@app/api/public/ContentEventApi';
import { useMutation, useQueryClient } from 'react-query';
import { memberEventQueryKeys } from './memberEventQueries';

type Variables = { id: number };

const useSetEventAsDraft = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return ContentEventApi.setEventAsDraft(varables.id);
        },
        {
            onSettled: (data, error, varables) => {
                client.invalidateQueries(memberEventQueryKeys.lists());
                client.invalidateQueries(memberEventQueryKeys.detail(varables.id));
            },
        }
    );
};

export default useSetEventAsDraft;
